import { Injectable } from '@angular/core';

export class Message {
  constructor (
    public name: string,
    public email: string,
    public phone: string,
    public message: string,
    public focused: boolean
  ) {}
}

@Injectable()
export class MessageService {
   createMessage(message: Message) {
     console.log('Name: ' + message.name);
     console.log('E-Mail Address: ' + message.email);
     console.log('Phone Number: ' + message.phone);
     console.log('Message: ' + message.message);
   }
} 